import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@tsuyosa/auth';

type State = 'verifying' | 'success' | 'error';

export function VerifyEmailPage() {
  const { verifyEmail, user } = useAuth();
  const [searchParams]        = useSearchParams();
  const navigate              = useNavigate();

  const [state, setState]   = useState<State>('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (user) { navigate('/'); return; }

    const token = searchParams.get('token');
    if (!token) {
      setState('error');
      setMessage('Token verifikasi tidak ditemukan. Pastikan kamu membuka link dari email.');
      return;
    }

    verifyEmail(token)
      .then(() => {
        setState('success');
        setTimeout(() => navigate('/'), 2500);
      })
      .catch((err: Error) => {
        setState('error');
        setMessage(err.message || 'Verifikasi gagal. Link mungkin sudah kadaluarsa.');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0d0a12] px-4">
      <div className="w-full max-w-sm text-center">
        <h1 className="mb-8 text-3xl font-bold text-gradient-tsuyosa">TSUN</h1>

        {state === 'verifying' && (
          <div className="rounded-xl border border-white/5 bg-[#130d1a] p-8">
            <span className="mb-4 inline-block h-8 w-8 animate-spin rounded-full border-2 border-[#f472b6] border-t-transparent" />
            <p className="mt-4 text-sm text-white/60">Memverifikasi email kamu…</p>
          </div>
        )}

        {state === 'success' && (
          <div className="rounded-xl border border-white/5 bg-[#130d1a] p-8">
            <div className="mb-4 flex justify-center">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-green-500/15 text-3xl">
                ✓
              </span>
            </div>
            <h2 className="mb-2 text-lg font-semibold text-white">Email terverifikasi!</h2>
            <p className="text-sm text-white/50">
              Akun kamu sudah aktif. Mengalihkan ke beranda…
            </p>
          </div>
        )}

        {state === 'error' && (
          <div className="rounded-xl border border-white/5 bg-[#130d1a] p-8">
            <div className="mb-4 flex justify-center">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-red-500/15 text-3xl">
                ✕
              </span>
            </div>
            <h2 className="mb-2 text-lg font-semibold text-white">Verifikasi gagal</h2>
            <p className="mb-5 text-sm text-white/50">{message}</p>
            <Link
              to="/login"
              className="inline-block rounded-lg bg-[#f472b6] px-5 py-2.5 text-sm font-semibold text-white shadow-[0_0_12px_rgba(244,114,182,0.35)] transition-all hover:bg-[#ec4899]"
            >
              Kembali ke Login
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
